import React, { useState } from 'react'; // Añadido useState
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import { collection, addDoc } from "firebase/firestore"
import { db } from "../firebase-config"
import { useNavigate } from "react-router-dom"

const Contacto = () => {
  let navigate = useNavigate();
  
  // Estado para el Toast personalizado
  const [toast, setToast] = useState({ show: false, msg: '', color: '' });

  function mostrarToast(mensaje, color = 'bg-slate-800') {
    setToast({ show: true, msg: mensaje, color: color });
    setTimeout(() => {
      setToast({ show: false, msg: '', color: '' });
    }, 4000);
  }

  function Enviar() {
    const nombre = document.getElementById("nombre").value;
    const email = document.getElementById("email").value;
    const asunto = document.getElementById("asunto").value;
    const mensaje = document.getElementById("mensaje").value;
    
    const emailBody = `
      <p>Email: ${email}</p>
      <hr />
      <p>Nombre: ${nombre}</p>
      <hr />
      <p>Asunto: ${asunto}</p>
      <hr />
      <p>Mensaje: ${mensaje}</p>
    `;

    const collectionRef = collection(db, "mail");
    const emailContent = {
      to: ['fundadocentejdd@gmail.com'],
      message: {
        subject: 'FORMULARIO CONTACTO PAGINA WEB',
        text: 'Formulario de contacto recibido.',
        html: emailBody,
      }
    };

    if(nombre === '' || asunto === '' || mensaje === '' || email === ''){
      mostrarToast("Por favor, completar formulario", "bg-red-500");
    } else {
      // Opcional: mostrar un aviso de "Enviando..."
      mostrarToast("Enviando mensaje...", "bg-blue-500");

      addDoc(collectionRef, emailContent)
      .then(() => {
        mostrarToast("¡Mensaje enviado con éxito!", "bg-green-600");
        // Limpiar campos
        document.getElementById("nombre").value = "";
        document.getElementById("email").value = "";
        document.getElementById("asunto").value = "";
        document.getElementById("mensaje").value = "";
      })
      .catch((error) => {
        mostrarToast("Error: " + error.message, "bg-red-500");
      });
    }
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />

      {/* TOAST ESTÉTICO (SIN LIBRERÍAS) */}
      <div className={`fixed bottom-10 left-1/2 -translate-x-1/2 z-[100] transition-all duration-500 ${toast.show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`}>
        <div className={`${toast.color} text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center space-x-3 border border-white/20 backdrop-blur-sm`}>
          <span className='font-bold text-sm md:text-base'>{toast.msg}</span>
        </div>
      </div>

      <div className='bg-gray-50 min-h-screen pt-28 pb-16 px-4'>
        <div className='max-w-6xl mx-auto'>
          
          <div className='bg-blue-600 text-white rounded-2xl p-4 mb-10 shadow-lg text-center'>
            <p className='font-medium text-sm md:text-base'>
              Llámanos: +57 300 753 19 88 | Barranquilla, Atlántico | fundadocentejdd@gmail.com
            </p>
          </div>

          <div className='bg-white shadow-2xl rounded-[2.5rem] overflow-hidden border border-gray-100 grid md:grid-cols-2'>
            
            <div className='flex flex-col p-8 md:p-12'>
              <div className='mb-6'>
                <h1 className='text-3xl md:text-5xl font-black text-slate-900 mb-2 uppercase'>
                  CONTÁCTANOS
                </h1>
                <p className='text-slate-500 font-medium'>
                  ¡Regístrate Ahora! ¿Tienes Preguntas o Sugerencias?
                </p>
              </div>
              
              <div className='flex-grow min-h-[350px] relative rounded-3xl overflow-hidden border border-gray-200 shadow-inner'>
                <iframe
                  className='absolute inset-0 h-full w-full'
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.4868572650307!2d-74.82511802545099!3d11.002051654992492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ef42daa11639d09%3A0x2fd8b8552b32ff28!2sCra.%2045%20%2385-154%2C%20Nte.%20Centro%20Historico%2C%20Barranquilla%2C%20Atl%C3%A1ntico!5e0!3m2!1ses!2sco!4v1690288828582!5m2!1ses!2sco"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Mapa"
                  referrerPolicy="no-referrer-when-downgrade">
                </iframe>
              </div>
            </div>

            <div className='bg-slate-50 p-8 md:p-12 flex flex-col justify-center space-y-5'>
              
              <div className='space-y-1'>
                <label className='text-[10px] font-bold text-blue-600 uppercase tracking-widest ml-2'>Nombre *</label>
                <input id="nombre" type='text' placeholder="Escribe tu nombre" className='w-full border-0 bg-white shadow-sm rounded-2xl p-4 outline-none focus:ring-2 focus:ring-blue-500 transition-all text-slate-700' />
              </div>

              <div className='space-y-1'>
                <label className='text-[10px] font-bold text-blue-600 uppercase tracking-widest ml-2'>Email *</label>
                <input id="email" type='email' placeholder="tu@email.com" className='w-full border-0 bg-white shadow-sm rounded-2xl p-4 outline-none focus:ring-2 focus:ring-blue-500 transition-all text-slate-700' />
              </div>

              <div className='space-y-1'>
                <label className='text-[10px] font-bold text-blue-600 uppercase tracking-widest ml-2'>Asunto *</label>
                <input id="asunto" type='text' placeholder="Motivo de contacto" className='w-full border-0 bg-white shadow-sm rounded-2xl p-4 outline-none focus:ring-2 focus:ring-blue-500 transition-all text-slate-700' />
              </div>

              <div className='space-y-1'>
                <label className='text-[10px] font-bold text-blue-600 uppercase tracking-widest ml-2'>Mensaje</label>
                <textarea id='mensaje' placeholder="Tu mensaje aquí..." rows="4" className='w-full border-0 bg-white shadow-sm rounded-2xl p-4 outline-none focus:ring-2 focus:ring-blue-500 transition-all resize-none text-slate-700'></textarea>
              </div>

              <button 
                onClick={Enviar} 
                className='w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-2xl shadow-lg transition-all transform hover:-translate-y-1 active:scale-95'
              >
                Enviar Ahora
              </button>

            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contacto;